module.exports = __webpack_public_path__ + "img/k.ee190d51.gif";